var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    ref: "container",
    staticClass: "mt-8 md:mt-32"
  }, [_c('div', {
    staticClass: "hidden lg:block mx-auto relative -mb-60 max-w-[1110.39px] z-50"
  }, [_c('div', {
    ref: "statGrid",
    staticClass: "grid grid-cols-4 gap-x-3 xl:gap-x-[30px]"
  }, [_c('svg', {
    ref: "esg-stat-1",
    attrs: {
      "width": "256",
      "height": "256",
      "viewBox": "0 0 256 256",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('rect', {
    attrs: {
      "width": "255.099",
      "height": "255.099",
      "rx": "5.66886",
      "fill": "white"
    }
  }), _vm._v(" "), _c('g', {
    attrs: {
      "filter": "url(#filter0_d_4887_40067)"
    }
  }, [_c('rect', {
    attrs: {
      "x": "233.841",
      "y": "212.61",
      "width": "11.3377",
      "height": "212.582",
      "rx": "5.66886",
      "transform": "rotate(90 233.841 212.61)",
      "fill": "#ED896F",
      "fill-opacity": "0.2",
      "shape-rendering": "crispEdges"
    }
  })]), _vm._v(" "), _c('rect', {
    staticClass: "bar",
    attrs: {
      "x": "54.0032",
      "y": "221.611",
      "width": "11",
      "height": "211.895",
      "rx": "5.5",
      "transform": "rotate(-90.0166 39.0032 239.06)",
      "fill": "#ED896F"
    }
  }), _vm._v(" "), _c('text', {
    style: `
            font-family: 'Mazzard Soft M';
            font-style: normal;
            font-weight: 700;
            font-size: 17;
            line-height: 23px;
            letter-spacing: 0.04em;
            text-transform: uppercase;
        `,
    attrs: {
      "x": "13",
      "y": "25",
      "fill": "rgba(237, 137, 111, 1)"
    }
  }, [_c('tspan', {
    attrs: {
      "x": "13",
      "dy": "1em"
    }
  }, [_vm._v("Improve well-being")]), _vm._v(" "), _c('tspan', {
    attrs: {
      "x": "13",
      "dy": "1.2em"
    }
  }, [_vm._v("outcomes")])]), _vm._v(" "), _c('text', {
    staticClass: "stat-number",
    staticStyle: {
      "font-family": "'Mazzard Soft M'",
      "font-style": "normal",
      "font-weight": "400",
      "font-size": "56.6886px",
      "line-height": "71px",
      "letter-spacing": "-0.02em"
    },
    attrs: {
      "x": "20",
      "y": "190",
      "fill": "#292832"
    }
  }), _vm._v(" "), _c('text', {
    style: `
            font-family: 'Mazzard Soft M';
            font-style: normal;
            font-weight: 400;
            font-size: 56.6886px;
            line-height: 71px;
            letter-spacing: -0.02em;
        `,
    attrs: {
      "x": "88",
      "y": "190",
      "fill": "#292832"
    }
  }, [_vm._v("\n          %\n        ")]), _vm._v(" "), _c('path', {
    staticClass: "arrow-up",
    attrs: {
      "d": "M183.678 160.574C184.23 160.036 185.11 160.037 185.661 160.576L198.795 173.451C199.066 173.716 199.219 174.079 199.22 174.458C199.222 174.837 199.071 175.201 198.802 175.468L195.086 179.161C194.547 179.696 193.681 179.712 193.123 179.195L188.988 175.363V189.932C188.988 190.715 188.353 191.35 187.57 191.35H181.716C180.933 191.35 180.299 190.715 180.299 189.932V175.38L176.218 179.191C175.664 179.709 174.8 179.698 174.258 179.168L170.491 175.475C170.219 175.208 170.066 174.843 170.066 174.461C170.066 174.08 170.22 173.715 170.493 173.449L183.678 160.574Z",
      "fill": "white",
      "stroke": "#ACAABB",
      "stroke-width": "2.83443",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M205.133 189.826C204.946 189.996 204.81 190.319 204.81 190.574V191.016C204.81 191.34 205.065 191.595 205.388 191.595H212.259C212.582 191.595 212.837 191.34 212.837 191.016V190.285C212.837 189.962 212.582 189.724 212.259 189.724H207.837L210.286 187.394C211.936 185.829 212.735 184.622 212.735 183.397C212.735 181.476 210.967 179.894 208.722 179.894C207.072 179.894 205.661 180.761 204.861 182.122C204.691 182.394 204.827 182.734 205.116 182.87L205.916 183.261C205.984 183.295 206.069 183.312 206.137 183.312C206.341 183.312 206.545 183.21 206.664 183.006C207.123 182.241 207.854 181.765 208.722 181.765C209.81 181.765 210.695 182.53 210.695 183.448C210.695 184.18 210.15 185.03 209.062 186.084L205.133 189.826ZM214.633 189.826C214.446 189.996 214.31 190.319 214.31 190.574V191.016C214.31 191.34 214.565 191.595 214.888 191.595H221.759C222.082 191.595 222.337 191.34 222.337 191.016V190.285C222.337 189.962 222.082 189.724 221.759 189.724H217.337L219.786 187.394C221.436 185.829 222.235 184.622 222.235 183.397C222.235 181.476 220.466 179.894 218.222 179.894C216.572 179.894 215.16 180.761 214.361 182.122C214.191 182.394 214.327 182.734 214.616 182.87L215.415 183.261C215.483 183.295 215.569 183.312 215.637 183.312C215.841 183.312 216.045 183.21 216.164 183.006C216.623 182.241 217.354 181.765 218.222 181.765C219.31 181.765 220.194 182.53 220.194 183.448C220.194 184.18 219.65 185.03 218.562 186.084L214.633 189.826ZM225.51 190.302C225.323 190.523 225.34 190.846 225.561 191.033L225.851 191.271C225.953 191.357 226.055 191.391 226.174 191.391C226.327 191.391 226.463 191.322 226.582 191.203L234.779 181.425C234.966 181.187 234.949 180.88 234.728 180.693L234.422 180.438C234.32 180.353 234.201 180.319 234.099 180.319C233.946 180.319 233.793 180.387 233.691 180.506L225.51 190.302ZM223.572 182.836C223.572 184.52 224.847 185.778 226.531 185.778C228.215 185.778 229.473 184.52 229.473 182.836C229.473 181.17 228.215 179.894 226.531 179.894C224.847 179.894 223.572 181.17 223.572 182.836ZM225.289 182.836C225.289 182.156 225.834 181.612 226.531 181.612C227.211 181.612 227.755 182.156 227.755 182.836C227.755 183.533 227.211 184.061 226.531 184.061C225.834 184.061 225.289 183.533 225.289 182.836ZM230.749 188.857C230.749 190.557 232.024 191.816 233.691 191.816C235.374 191.816 236.65 190.557 236.65 188.857C236.65 187.207 235.374 185.931 233.691 185.931C232.024 185.931 230.749 187.207 230.749 188.857ZM232.466 188.857C232.466 188.176 233.01 187.649 233.691 187.649C234.388 187.649 234.915 188.176 234.915 188.857C234.915 189.554 234.388 190.098 233.691 190.098C233.01 190.098 232.466 189.554 232.466 188.857Z",
      "fill": "#292832"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "line",
    attrs: {
      "d": "M21.0887 117.655L48.8609 96.7771H71.8769H92.8057L126.677 104.497L148.597 96.7771L169.151 87.9856H190.245L215.453 79.2886L233.5 77.2886",
      "stroke": "#ED896F",
      "stroke-width": "4.25165"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "234.698",
      "y1": "69.4158",
      "x2": "234.698",
      "y2": "105.201",
      "stroke": "#DEDEE5",
      "stroke-width": "1.41722"
    }
  }), _vm._v(" "), _c('defs', [_c('filter', {
    attrs: {
      "id": "filter0_d_4887_40067",
      "x": "4.25183",
      "y": "198.438",
      "width": "246.596",
      "height": "45.351",
      "filterUnits": "userSpaceOnUse",
      "color-interpolation-filters": "sRGB"
    }
  }, [_c('feFlood', {
    attrs: {
      "flood-opacity": "0",
      "result": "BackgroundImageFix"
    }
  }), _vm._v(" "), _c('feColorMatrix', {
    attrs: {
      "in": "SourceAlpha",
      "type": "matrix",
      "values": "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
      "result": "hardAlpha"
    }
  }), _vm._v(" "), _c('feOffset', {
    attrs: {
      "dy": "2.83443"
    }
  }), _vm._v(" "), _c('feGaussianBlur', {
    attrs: {
      "stdDeviation": "8.5033"
    }
  }), _vm._v(" "), _c('feComposite', {
    attrs: {
      "in2": "hardAlpha",
      "operator": "out"
    }
  }), _vm._v(" "), _c('feColorMatrix', {
    attrs: {
      "type": "matrix",
      "values": "0 0 0 0 0.247059 0 0 0 0 0.227451 0 0 0 0 0.282353 0 0 0 0.04 0"
    }
  }), _vm._v(" "), _c('feBlend', {
    attrs: {
      "mode": "normal",
      "in2": "BackgroundImageFix",
      "result": "effect1_dropShadow_4887_40067"
    }
  }), _vm._v(" "), _c('feBlend', {
    attrs: {
      "mode": "normal",
      "in": "SourceGraphic",
      "in2": "effect1_dropShadow_4887_40067",
      "result": "shape"
    }
  })], 1), _vm._v(" "), _c('filter', {
    attrs: {
      "id": "filter1_d_4887_40067",
      "x": "4.25299",
      "y": "198.436",
      "width": "145.588",
      "height": "45.351",
      "filterUnits": "userSpaceOnUse",
      "color-interpolation-filters": "sRGB"
    }
  }, [_c('feFlood', {
    attrs: {
      "flood-opacity": "0",
      "result": "BackgroundImageFix"
    }
  }), _vm._v(" "), _c('feColorMatrix', {
    attrs: {
      "in": "SourceAlpha",
      "type": "matrix",
      "values": "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
      "result": "hardAlpha"
    }
  }), _vm._v(" "), _c('feOffset', {
    attrs: {
      "dy": "2.83443"
    }
  }), _vm._v(" "), _c('feGaussianBlur', {
    attrs: {
      "stdDeviation": "8.5033"
    }
  }), _vm._v(" "), _c('feComposite', {
    attrs: {
      "in2": "hardAlpha",
      "operator": "out"
    }
  }), _vm._v(" "), _c('feColorMatrix', {
    attrs: {
      "type": "matrix",
      "values": "0 0 0 0 0.247059 0 0 0 0 0.227451 0 0 0 0 0.282353 0 0 0 0.04 0"
    }
  }), _vm._v(" "), _c('feBlend', {
    attrs: {
      "mode": "normal",
      "in2": "BackgroundImageFix",
      "result": "effect1_dropShadow_4887_40067"
    }
  }), _vm._v(" "), _c('feBlend', {
    attrs: {
      "mode": "normal",
      "in": "SourceGraphic",
      "in2": "effect1_dropShadow_4887_40067",
      "result": "shape"
    }
  })], 1)])]), _vm._v(" "), _c('svg', {
    ref: "esg-stat-2",
    attrs: {
      "width": "256",
      "height": "256",
      "viewBox": "0 0 256 256",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('rect', {
    attrs: {
      "x": "0.0986328",
      "width": "255.099",
      "height": "255.099",
      "rx": "5.66886",
      "fill": "white"
    }
  }), _vm._v(" "), _c('g', {
    attrs: {
      "filter": "url(#filter0_d_4887_40022)"
    }
  }, [_c('rect', {
    attrs: {
      "x": "233.939",
      "y": "212.611",
      "width": "11.3377",
      "height": "212.582",
      "rx": "5.66886",
      "transform": "rotate(90 233.939 212.611)",
      "fill": "#327DB9",
      "fill-opacity": "0.2",
      "shape-rendering": "crispEdges"
    }
  })]), _vm._v(" "), _c('rect', {
    staticClass: "bar",
    attrs: {
      "x": "54.0032",
      "y": "221.611",
      "width": "11",
      "height": "211.895",
      "rx": "5.5",
      "transform": "rotate(-90.0166 39.0032 239.06)",
      "fill": "#327DB9"
    }
  }), _vm._v(" "), _c('text', {
    style: `
            font-family: 'Mazzard Soft M';
            font-style: normal;
            font-weight: 700;
            font-size: 17;
            line-height: 23px;
            letter-spacing: 0.04em;
            text-transform: uppercase;
        `,
    attrs: {
      "x": "13",
      "y": "25",
      "fill": "rgba(50, 125, 185, 1)"
    }
  }, [_c('tspan', {
    attrs: {
      "x": "13",
      "dy": "1em"
    }
  }, [_vm._v("Increase")]), _vm._v(" "), _c('tspan', {
    attrs: {
      "x": "13",
      "dy": "1.2em"
    }
  }, [_vm._v("engagement")])]), _vm._v(" "), _c('text', {
    staticClass: "stat-number",
    staticStyle: {
      "font-family": "'Mazzard Soft M'",
      "font-style": "normal",
      "font-weight": "400",
      "font-size": "56.6886px",
      "line-height": "71px",
      "letter-spacing": "-0.02em"
    },
    attrs: {
      "x": "20",
      "y": "190",
      "fill": "#292832"
    }
  }), _vm._v(" "), _c('text', {
    style: `
            font-family: 'Mazzard Soft M';
            font-style: normal;
            font-weight: 400;
            font-size: 56.6886px;
            line-height: 71px;
            letter-spacing: -0.02em;
        `,
    attrs: {
      "x": "88",
      "y": "190",
      "fill": "#292832"
    }
  }, [_vm._v("\n          %\n        ")]), _vm._v(" "), _c('path', {
    staticClass: "arrow-down",
    attrs: {
      "d": "M183.777 190.947C184.328 191.485 185.209 191.484 185.759 190.945L198.894 178.07C199.164 177.805 199.317 177.442 199.319 177.063C199.32 176.684 199.169 176.32 198.9 176.053L195.184 172.36C194.645 171.824 193.779 171.809 193.222 172.326L189.086 176.158V161.588C189.086 160.806 188.452 160.171 187.669 160.171H181.814C181.032 160.171 180.397 160.806 180.397 161.588V176.141L176.316 172.329C175.762 171.812 174.899 171.822 174.357 172.353L170.59 176.046C170.317 176.313 170.164 176.678 170.165 177.059C170.165 177.441 170.319 177.806 170.592 178.072L183.777 190.947Z",
      "fill": "white",
      "stroke": "#ACAABB",
      "stroke-width": "2.83443",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M205.504 171.703C205.606 171.924 205.793 172.043 205.997 172.043C206.082 172.043 206.167 172.026 206.252 171.975L207.817 171.193V179.679C207.817 180.002 208.055 180.257 208.395 180.257H209.194C209.518 180.257 209.756 180.002 209.756 179.679V169.356C209.756 169.016 209.518 168.778 209.194 168.778H208.82C208.582 168.778 208.225 168.863 207.987 168.982L205.436 170.257C205.147 170.393 205.028 170.734 205.181 171.04L205.504 171.703ZM211.925 170.002C211.925 170.325 212.163 170.58 212.486 170.58H217.758L213.83 179.73C213.693 180.019 213.83 180.257 214.17 180.257H215.139C215.462 180.257 215.819 180.019 215.955 179.73L219.595 171.193C219.731 170.904 219.833 170.427 219.833 170.104V169.356C219.833 169.016 219.578 168.778 219.255 168.778H212.486C212.163 168.778 211.925 169.016 211.925 169.356V170.002ZM222.736 178.965C222.549 179.186 222.566 179.509 222.787 179.696L223.076 179.934C223.178 180.019 223.28 180.053 223.399 180.053C223.552 180.053 223.688 179.985 223.807 179.866L232.004 170.087C232.191 169.849 232.174 169.543 231.953 169.356L231.647 169.101C231.545 169.016 231.426 168.982 231.324 168.982C231.171 168.982 231.018 169.05 230.916 169.169L222.736 178.965ZM220.797 171.499C220.797 173.182 222.073 174.441 223.756 174.441C225.44 174.441 226.698 173.182 226.698 171.499C226.698 169.832 225.44 168.557 223.756 168.557C222.073 168.557 220.797 169.832 220.797 171.499ZM222.515 171.499C222.515 170.819 223.059 170.274 223.756 170.274C224.436 170.274 224.981 170.819 224.981 171.499C224.981 172.196 224.436 172.723 223.756 172.723C223.059 172.723 222.515 172.196 222.515 171.499ZM227.974 177.519C227.974 179.22 229.249 180.478 230.916 180.478C232.6 180.478 233.875 179.22 233.875 177.519C233.875 175.87 232.6 174.594 230.916 174.594C229.249 174.594 227.974 175.87 227.974 177.519ZM229.692 177.519C229.692 176.839 230.236 176.312 230.916 176.312C231.613 176.312 232.14 176.839 232.14 177.519C232.14 178.216 231.613 178.761 230.916 178.761C230.236 178.761 229.692 178.216 229.692 177.519Z",
      "fill": "#292832"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "line",
    attrs: {
      "d": "M21.1855 117.655L44.446 114.523L69.4958 102.446H98.5714L121.832 93.0523L143.75 87.2371L169.247 82.3167H194.745L217.558 87.2371L234.108 93.0523",
      "stroke": "#327DB9",
      "stroke-width": "4.25165"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "234.795",
      "y1": "76.5017",
      "x2": "234.795",
      "y2": "112.287",
      "stroke": "#DEDEE5",
      "stroke-width": "1.41722"
    }
  }), _vm._v(" "), _c('defs', [_c('filter', {
    attrs: {
      "id": "filter0_d_4887_40022",
      "x": "4.35046",
      "y": "198.439",
      "width": "246.596",
      "height": "45.351",
      "filterUnits": "userSpaceOnUse",
      "color-interpolation-filters": "sRGB"
    }
  }, [_c('feFlood', {
    attrs: {
      "flood-opacity": "0",
      "result": "BackgroundImageFix"
    }
  }), _vm._v(" "), _c('feColorMatrix', {
    attrs: {
      "in": "SourceAlpha",
      "type": "matrix",
      "values": "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
      "result": "hardAlpha"
    }
  }), _vm._v(" "), _c('feOffset', {
    attrs: {
      "dy": "2.83443"
    }
  }), _vm._v(" "), _c('feGaussianBlur', {
    attrs: {
      "stdDeviation": "8.5033"
    }
  }), _vm._v(" "), _c('feComposite', {
    attrs: {
      "in2": "hardAlpha",
      "operator": "out"
    }
  }), _vm._v(" "), _c('feColorMatrix', {
    attrs: {
      "type": "matrix",
      "values": "0 0 0 0 0.247059 0 0 0 0 0.227451 0 0 0 0 0.282353 0 0 0 0.04 0"
    }
  }), _vm._v(" "), _c('feBlend', {
    attrs: {
      "mode": "normal",
      "in2": "BackgroundImageFix",
      "result": "effect1_dropShadow_4887_40022"
    }
  }), _vm._v(" "), _c('feBlend', {
    attrs: {
      "mode": "normal",
      "in": "SourceGraphic",
      "in2": "effect1_dropShadow_4887_40022",
      "result": "shape"
    }
  })], 1), _vm._v(" "), _c('filter', {
    attrs: {
      "id": "filter1_d_4887_40022",
      "x": "4.35075",
      "y": "198.436",
      "width": "164.397",
      "height": "45.351",
      "filterUnits": "userSpaceOnUse",
      "color-interpolation-filters": "sRGB"
    }
  }, [_c('feFlood', {
    attrs: {
      "flood-opacity": "0",
      "result": "BackgroundImageFix"
    }
  }), _vm._v(" "), _c('feColorMatrix', {
    attrs: {
      "in": "SourceAlpha",
      "type": "matrix",
      "values": "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
      "result": "hardAlpha"
    }
  }), _vm._v(" "), _c('feOffset', {
    attrs: {
      "dy": "2.83443"
    }
  }), _vm._v(" "), _c('feGaussianBlur', {
    attrs: {
      "stdDeviation": "8.5033"
    }
  }), _vm._v(" "), _c('feComposite', {
    attrs: {
      "in2": "hardAlpha",
      "operator": "out"
    }
  }), _vm._v(" "), _c('feColorMatrix', {
    attrs: {
      "type": "matrix",
      "values": "0 0 0 0 0.247059 0 0 0 0 0.227451 0 0 0 0 0.282353 0 0 0 0.04 0"
    }
  }), _vm._v(" "), _c('feBlend', {
    attrs: {
      "mode": "normal",
      "in2": "BackgroundImageFix",
      "result": "effect1_dropShadow_4887_40022"
    }
  }), _vm._v(" "), _c('feBlend', {
    attrs: {
      "mode": "normal",
      "in": "SourceGraphic",
      "in2": "effect1_dropShadow_4887_40022",
      "result": "shape"
    }
  })], 1)])]), _vm._v(" "), _c('svg', {
    ref: "esg-stat-3",
    attrs: {
      "width": "256",
      "height": "256",
      "viewBox": "0 0 256 256",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('rect', {
    attrs: {
      "x": "0.197266",
      "width": "255.099",
      "height": "255.099",
      "rx": "5.66886",
      "fill": "white"
    }
  }), _vm._v(" "), _c('g', {
    attrs: {
      "filter": "url(#filter0_d_4887_40052)"
    }
  }, [_c('rect', {
    attrs: {
      "x": "234.038",
      "y": "212.611",
      "width": "11.3377",
      "height": "212.582",
      "rx": "5.66886",
      "transform": "rotate(90 234.038 212.611)",
      "fill": "#985F8C",
      "fill-opacity": "0.2",
      "shape-rendering": "crispEdges"
    }
  })]), _vm._v(" "), _c('rect', {
    staticClass: "bar",
    attrs: {
      "x": "54.0032",
      "y": "221.611",
      "width": "11",
      "height": "211.895",
      "rx": "5.5",
      "transform": "rotate(-90.0166 39.0032 239.06)",
      "fill": "#985F8C"
    }
  }), _vm._v(" "), _c('text', {
    style: `
            font-family: 'Mazzard Soft M';
            font-style: normal;
            font-weight: 700;
            font-size: 17;
            line-height: 23px;
            letter-spacing: 0.04em;
            text-transform: uppercase;
        `,
    attrs: {
      "x": "13",
      "y": "25",
      "fill": "rgba(152, 95, 140, 1)"
    }
  }, [_c('tspan', {
    attrs: {
      "x": "13",
      "dy": "1em"
    }
  }, [_vm._v("Improve")]), _vm._v(" "), _c('tspan', {
    attrs: {
      "x": "13",
      "dy": "1.2em"
    }
  }, [_vm._v("Retention")])]), _vm._v(" "), _c('text', {
    staticClass: "stat-number",
    staticStyle: {
      "font-family": "'Mazzard Soft M'",
      "font-style": "normal",
      "font-weight": "400",
      "font-size": "56.6886px",
      "line-height": "71px",
      "letter-spacing": "-0.02em"
    },
    attrs: {
      "x": "20",
      "y": "190",
      "fill": "#292832"
    }
  }), _vm._v(" "), _c('text', {
    style: `
            font-family: 'Mazzard Soft M';
            font-style: normal;
            font-weight: 400;
            font-size: 56.6886px;
            line-height: 71px;
            letter-spacing: -0.02em;
        `,
    attrs: {
      "x": "88",
      "y": "190",
      "fill": "#292832"
    }
  }, [_vm._v("\n          %\n        ")]), _vm._v(" "), _c('path', {
    staticClass: "arrow-up",
    attrs: {
      "d": "M183.875 160.574C184.426 160.036 185.307 160.037 185.857 160.576L198.992 173.451C199.262 173.716 199.416 174.079 199.417 174.458C199.418 174.837 199.267 175.201 198.999 175.468L195.282 179.161C194.743 179.697 193.877 179.712 193.32 179.195L189.184 175.363V189.933C189.184 190.715 188.55 191.35 187.767 191.35H181.912C181.13 191.35 180.495 190.715 180.495 189.933V175.38L176.414 179.192C175.86 179.709 174.997 179.699 174.455 179.168L170.688 175.475C170.416 175.208 170.262 174.843 170.263 174.462C170.263 174.08 170.417 173.715 170.69 173.449L183.875 160.574Z",
      "fill": "white",
      "stroke": "#ACAABB",
      "stroke-width": "2.83443",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M205.602 183.041C205.704 183.262 205.891 183.381 206.095 183.381C206.18 183.381 206.265 183.364 206.35 183.313L207.915 182.53V191.017C207.915 191.34 208.153 191.595 208.493 191.595H209.292C209.615 191.595 209.854 191.34 209.854 191.017V180.694C209.854 180.354 209.615 180.116 209.292 180.116H208.918C208.68 180.116 208.323 180.201 208.085 180.32L205.534 181.595C205.245 181.731 205.126 182.071 205.279 182.377L205.602 183.041ZM218.655 182.496C218.825 182.667 219.029 182.752 219.233 182.752C219.319 182.752 219.387 182.735 219.472 182.701L220.271 182.309C220.577 182.156 220.662 181.816 220.475 181.578C219.693 180.541 218.383 179.894 216.87 179.894C214.353 179.894 212.465 181.663 212.465 183.993V188.024C212.465 190.166 214.302 191.816 216.751 191.816C219.182 191.816 221.036 190.183 221.036 188.058C221.036 185.881 219.182 184.231 216.768 184.231C215.866 184.231 215.05 184.486 214.421 184.911V183.959C214.421 182.718 215.458 181.765 216.836 181.765C217.584 181.765 218.23 182.054 218.655 182.496ZM216.751 186.102C218.026 186.102 218.995 186.935 218.995 188.058C218.995 189.129 218.026 189.945 216.751 189.945C215.458 189.945 214.489 189.112 214.489 188.007C214.489 186.935 215.458 186.102 216.751 186.102ZM224.096 190.302C223.909 190.524 223.926 190.847 224.147 191.034L224.436 191.272C224.538 191.357 224.64 191.391 224.759 191.391C224.912 191.391 225.048 191.323 225.167 191.204L233.365 181.425C233.552 181.187 233.535 180.881 233.313 180.694L233.007 180.439C232.905 180.354 232.786 180.32 232.684 180.32C232.531 180.32 232.378 180.388 232.276 180.507L224.096 190.302ZM222.157 182.837C222.157 184.52 223.433 185.779 225.116 185.779C226.8 185.779 228.058 184.52 228.058 182.837C228.058 181.17 226.8 179.894 225.116 179.894C223.433 179.894 222.157 181.17 222.157 182.837ZM223.875 182.837C223.875 182.156 224.419 181.612 225.116 181.612C225.797 181.612 226.341 182.156 226.341 182.837C226.341 183.534 225.797 184.061 225.116 184.061C224.419 184.061 223.875 183.534 223.875 182.837ZM229.334 188.857C229.334 190.558 230.609 191.816 232.276 191.816C233.96 191.816 235.235 190.558 235.235 188.857C235.235 187.207 233.96 185.932 232.276 185.932C230.609 185.932 229.334 187.207 229.334 188.857ZM231.052 188.857C231.052 188.177 231.596 187.649 232.276 187.649C232.973 187.649 233.501 188.177 233.501 188.857C233.501 189.554 232.973 190.098 232.276 190.098C231.596 190.098 231.052 189.554 231.052 188.857Z",
      "fill": "#292832"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "line",
    attrs: {
      "d": "M21.2843 117.655L44.5448 108.855L69.5945 102.446H98.6631L121.931 93.0524L147.387 108.855L169.346 87.9857L197.329 102.446H215.601L232.571 87.2373",
      "stroke": "#985F8C",
      "stroke-width": "4.25165"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "234.893",
      "y1": "69.4163",
      "x2": "234.893",
      "y2": "105.202",
      "stroke": "#DEDEE5",
      "stroke-width": "1.41722"
    }
  }), _vm._v(" "), _c('defs', [_c('filter', {
    attrs: {
      "id": "filter0_d_4887_40052",
      "x": "4.4491",
      "y": "198.439",
      "width": "246.596",
      "height": "45.351",
      "filterUnits": "userSpaceOnUse",
      "color-interpolation-filters": "sRGB"
    }
  }, [_c('feFlood', {
    attrs: {
      "flood-opacity": "0",
      "result": "BackgroundImageFix"
    }
  }), _vm._v(" "), _c('feColorMatrix', {
    attrs: {
      "in": "SourceAlpha",
      "type": "matrix",
      "values": "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
      "result": "hardAlpha"
    }
  }), _vm._v(" "), _c('feOffset', {
    attrs: {
      "dy": "2.83443"
    }
  }), _vm._v(" "), _c('feGaussianBlur', {
    attrs: {
      "stdDeviation": "8.5033"
    }
  }), _vm._v(" "), _c('feComposite', {
    attrs: {
      "in2": "hardAlpha",
      "operator": "out"
    }
  }), _vm._v(" "), _c('feColorMatrix', {
    attrs: {
      "type": "matrix",
      "values": "0 0 0 0 0.247059 0 0 0 0 0.227451 0 0 0 0 0.282353 0 0 0 0.04 0"
    }
  }), _vm._v(" "), _c('feBlend', {
    attrs: {
      "mode": "normal",
      "in2": "BackgroundImageFix",
      "result": "effect1_dropShadow_4887_40052"
    }
  }), _vm._v(" "), _c('feBlend', {
    attrs: {
      "mode": "normal",
      "in": "SourceGraphic",
      "in2": "effect1_dropShadow_4887_40052",
      "result": "shape"
    }
  })], 1), _vm._v(" "), _c('filter', {
    attrs: {
      "id": "filter1_d_4887_40052",
      "x": "4.44922",
      "y": "198.436",
      "width": "210.557",
      "height": "45.351",
      "filterUnits": "userSpaceOnUse",
      "color-interpolation-filters": "sRGB"
    }
  }, [_c('feFlood', {
    attrs: {
      "flood-opacity": "0",
      "result": "BackgroundImageFix"
    }
  }), _vm._v(" "), _c('feColorMatrix', {
    attrs: {
      "in": "SourceAlpha",
      "type": "matrix",
      "values": "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
      "result": "hardAlpha"
    }
  }), _vm._v(" "), _c('feOffset', {
    attrs: {
      "dy": "2.83443"
    }
  }), _vm._v(" "), _c('feGaussianBlur', {
    attrs: {
      "stdDeviation": "8.5033"
    }
  }), _vm._v(" "), _c('feComposite', {
    attrs: {
      "in2": "hardAlpha",
      "operator": "out"
    }
  }), _vm._v(" "), _c('feColorMatrix', {
    attrs: {
      "type": "matrix",
      "values": "0 0 0 0 0.247059 0 0 0 0 0.227451 0 0 0 0 0.282353 0 0 0 0.04 0"
    }
  }), _vm._v(" "), _c('feBlend', {
    attrs: {
      "mode": "normal",
      "in2": "BackgroundImageFix",
      "result": "effect1_dropShadow_4887_40052"
    }
  }), _vm._v(" "), _c('feBlend', {
    attrs: {
      "mode": "normal",
      "in": "SourceGraphic",
      "in2": "effect1_dropShadow_4887_40052",
      "result": "shape"
    }
  })], 1)])]), _vm._v(" "), _c('svg', {
    ref: "esg-stat-4",
    attrs: {
      "width": "256",
      "height": "256",
      "viewBox": "0 0 256 256",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('rect', {
    attrs: {
      "x": "0.295898",
      "width": "255.099",
      "height": "255.099",
      "rx": "5.66886",
      "fill": "white"
    }
  }), _vm._v(" "), _c('g', {
    attrs: {
      "filter": "url(#filter0_d_4887_40037)"
    }
  }, [_c('rect', {
    attrs: {
      "x": "234.136",
      "y": "212.611",
      "width": "11.3377",
      "height": "212.582",
      "rx": "5.66886",
      "transform": "rotate(90 234.136 212.611)",
      "fill": "#3C9EB7",
      "fill-opacity": "0.2",
      "shape-rendering": "crispEdges"
    }
  })]), _vm._v(" "), _c('rect', {
    staticClass: "bar",
    attrs: {
      "x": "54.0032",
      "y": "221.611",
      "width": "11",
      "height": "211.895",
      "rx": "5.5",
      "transform": "rotate(-90.0166 39.0032 239.06)",
      "fill": "#3C9EB7"
    }
  }), _vm._v(" "), _c('text', {
    style: `
            font-family: 'Mazzard Soft M';
            font-style: normal;
            font-weight: 700;
            font-size: 17;
            line-height: 23px;
            letter-spacing: 0.04em;
            text-transform: uppercase;
        `,
    attrs: {
      "x": "13",
      "y": "25",
      "fill": "#3C9EB7"
    }
  }, [_c('tspan', {
    attrs: {
      "x": "13",
      "dy": "1em"
    }
  }, [_vm._v("Demonstrate")]), _vm._v(" "), _c('tspan', {
    attrs: {
      "x": "13",
      "dy": "1.2em"
    }
  }, [_vm._v("leadership")])]), _vm._v(" "), _c('text', {
    staticClass: "stat-number",
    staticStyle: {
      "font-family": "'Mazzard Soft M'",
      "font-style": "normal",
      "font-weight": "400",
      "font-size": "56.6886px",
      "line-height": "71px",
      "letter-spacing": "-0.02em"
    },
    attrs: {
      "x": "20",
      "y": "190",
      "fill": "#292832"
    }
  }), _vm._v(" "), _c('text', {
    style: `
            font-family: 'Mazzard Soft M';
            font-style: normal;
            font-weight: 400;
            font-size: 56.6886px;
            line-height: 71px;
            letter-spacing: -0.02em;
        `,
    attrs: {
      "x": "88",
      "y": "190",
      "fill": "#292832"
    }
  }, [_vm._v("\n          %\n        ")]), _vm._v(" "), _c('path', {
    staticClass: "arrow-up",
    attrs: {
      "d": "M183.974 160.574C184.525 160.036 185.406 160.037 185.956 160.576L199.09 173.451C199.361 173.716 199.514 174.079 199.515 174.458C199.517 174.837 199.366 175.201 199.097 175.468L195.381 179.161C194.842 179.697 193.976 179.712 193.419 179.195L189.283 175.363V189.933C189.283 190.715 188.648 191.35 187.866 191.35H182.011C181.228 191.35 180.594 190.715 180.594 189.933V175.38L176.513 179.192C175.959 179.709 175.095 179.699 174.554 179.168L170.786 175.475C170.514 175.208 170.361 174.843 170.361 174.462C170.362 174.081 170.516 173.715 170.788 173.449L183.974 160.574Z",
      "fill": "white",
      "stroke": "#ACAABB",
      "stroke-width": "2.83443",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M205.428 189.826C205.241 189.996 205.105 190.32 205.105 190.575V191.017C205.105 191.34 205.36 191.595 205.684 191.595H212.554C212.877 191.595 213.132 191.34 213.132 191.017V190.286C213.132 189.962 212.877 189.724 212.554 189.724H208.132L210.581 187.394C212.231 185.83 213.03 184.622 213.03 183.398C213.03 181.476 211.262 179.895 209.017 179.895C207.367 179.895 205.956 180.762 205.156 182.122C204.986 182.395 205.122 182.735 205.411 182.871L206.211 183.262C206.279 183.296 206.364 183.313 206.432 183.313C206.636 183.313 206.84 183.211 206.959 183.007C207.418 182.241 208.149 181.765 209.017 181.765C210.105 181.765 210.99 182.531 210.99 183.449C210.99 184.18 210.445 185.031 209.357 186.085L205.428 189.826ZM216.306 190.303C216.119 190.524 216.136 190.847 216.357 191.034L216.646 191.272C216.748 191.357 216.85 191.391 216.969 191.391C217.122 191.391 217.258 191.323 217.377 191.204L225.574 181.425C225.761 181.187 225.744 180.881 225.523 180.694L225.217 180.439C225.115 180.354 224.996 180.32 224.894 180.32C224.741 180.32 224.588 180.388 224.486 180.507L216.306 190.303ZM214.367 182.837C214.367 184.52 215.642 185.779 217.326 185.779C219.01 185.779 220.268 184.52 220.268 182.837C220.268 181.17 219.01 179.895 217.326 179.895C215.642 179.895 214.367 181.17 214.367 182.837ZM216.085 182.837C216.085 182.156 216.629 181.612 217.326 181.612C218.006 181.612 218.551 182.156 218.551 182.837C218.551 183.534 218.006 184.061 217.326 184.061C216.629 184.061 216.085 183.534 216.085 182.837ZM221.544 188.857C221.544 190.558 222.819 191.816 224.486 191.816C226.17 191.816 227.445 190.558 227.445 188.857C227.445 187.207 226.17 185.932 224.486 185.932C222.819 185.932 221.544 187.207 221.544 188.857ZM223.261 188.857C223.261 188.177 223.806 187.65 224.486 187.65C225.183 187.65 225.71 188.177 225.71 188.857C225.71 189.554 225.183 190.099 224.486 190.099C223.806 190.099 223.261 189.554 223.261 188.857Z",
      "fill": "#292832"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "line",
    attrs: {
      "d": "M21.3829 117.655L44.6434 108.855L69.6932 102.446L93.0999 96.777L122.029 93.0522L143.948 87.2371L169.445 87.9854L196.108 87.9858L217.755 87.2371H232.669",
      "stroke": "#3C9EB7",
      "stroke-width": "4.25165"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "234.992",
      "y1": "69.416",
      "x2": "234.992",
      "y2": "105.201",
      "stroke": "#DEDEE5",
      "stroke-width": "1.41722"
    }
  }), _vm._v(" "), _c('defs', [_c('filter', {
    attrs: {
      "id": "filter0_d_4887_40037",
      "x": "4.547",
      "y": "198.438",
      "width": "246.596",
      "height": "45.351",
      "filterUnits": "userSpaceOnUse",
      "color-interpolation-filters": "sRGB"
    }
  }, [_c('feFlood', {
    attrs: {
      "flood-opacity": "0",
      "result": "BackgroundImageFix"
    }
  }), _vm._v(" "), _c('feColorMatrix', {
    attrs: {
      "in": "SourceAlpha",
      "type": "matrix",
      "values": "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
      "result": "hardAlpha"
    }
  }), _vm._v(" "), _c('feOffset', {
    attrs: {
      "dy": "2.83443"
    }
  }), _vm._v(" "), _c('feGaussianBlur', {
    attrs: {
      "stdDeviation": "8.5033"
    }
  }), _vm._v(" "), _c('feComposite', {
    attrs: {
      "in2": "hardAlpha",
      "operator": "out"
    }
  }), _vm._v(" "), _c('feColorMatrix', {
    attrs: {
      "type": "matrix",
      "values": "0 0 0 0 0.247059 0 0 0 0 0.227451 0 0 0 0 0.282353 0 0 0 0.04 0"
    }
  }), _vm._v(" "), _c('feBlend', {
    attrs: {
      "mode": "normal",
      "in2": "BackgroundImageFix",
      "result": "effect1_dropShadow_4887_40037"
    }
  }), _vm._v(" "), _c('feBlend', {
    attrs: {
      "mode": "normal",
      "in": "SourceGraphic",
      "in2": "effect1_dropShadow_4887_40037",
      "result": "shape"
    }
  })], 1), _vm._v(" "), _c('filter', {
    attrs: {
      "id": "filter1_d_4887_40037",
      "x": "4.54694",
      "y": "198.436",
      "width": "193.855",
      "height": "45.351",
      "filterUnits": "userSpaceOnUse",
      "color-interpolation-filters": "sRGB"
    }
  }, [_c('feFlood', {
    attrs: {
      "flood-opacity": "0",
      "result": "BackgroundImageFix"
    }
  }), _vm._v(" "), _c('feColorMatrix', {
    attrs: {
      "in": "SourceAlpha",
      "type": "matrix",
      "values": "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
      "result": "hardAlpha"
    }
  }), _vm._v(" "), _c('feOffset', {
    attrs: {
      "dy": "2.83443"
    }
  }), _vm._v(" "), _c('feGaussianBlur', {
    attrs: {
      "stdDeviation": "8.5033"
    }
  }), _vm._v(" "), _c('feComposite', {
    attrs: {
      "in2": "hardAlpha",
      "operator": "out"
    }
  }), _vm._v(" "), _c('feColorMatrix', {
    attrs: {
      "type": "matrix",
      "values": "0 0 0 0 0.247059 0 0 0 0 0.227451 0 0 0 0 0.282353 0 0 0 0.04 0"
    }
  }), _vm._v(" "), _c('feBlend', {
    attrs: {
      "mode": "normal",
      "in2": "BackgroundImageFix",
      "result": "effect1_dropShadow_4887_40037"
    }
  }), _vm._v(" "), _c('feBlend', {
    attrs: {
      "mode": "normal",
      "in": "SourceGraphic",
      "in2": "effect1_dropShadow_4887_40037",
      "result": "shape"
    }
  })], 1)])])])]), _vm._v(" "), _c('LayoutContainer', {
    staticClass: "lg:hidden -mb-52 md:-mb-60 z-50"
  }, [_c('ElementsSlider', [_c('svg', {
    ref: "esg-stat-1-mobile",
    staticClass: "slider__item mr-8",
    attrs: {
      "width": "256",
      "height": "256",
      "viewBox": "0 0 256 256",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('rect', {
    attrs: {
      "width": "255.099",
      "height": "255.099",
      "rx": "5.66886",
      "fill": "white"
    }
  }), _vm._v(" "), _c('g', {
    attrs: {
      "filter": "url(#filter0_d_4887_40067)"
    }
  }, [_c('rect', {
    attrs: {
      "x": "233.841",
      "y": "212.61",
      "width": "11.3377",
      "height": "212.582",
      "rx": "5.66886",
      "transform": "rotate(90 233.841 212.61)",
      "fill": "#ED896F",
      "fill-opacity": "0.2",
      "shape-rendering": "crispEdges"
    }
  })]), _vm._v(" "), _c('rect', {
    staticClass: "bar",
    attrs: {
      "x": "54.0032",
      "y": "221.611",
      "width": "11",
      "height": "211.895",
      "rx": "5.5",
      "transform": "rotate(-90.0166 39.0032 239.06)",
      "fill": "#ED896F"
    }
  }), _vm._v(" "), _c('text', {
    style: `
            font-family: 'Mazzard Soft M';
            font-style: normal;
            font-weight: 700;
            font-size: 17;
            line-height: 23px;
            letter-spacing: 0.04em;
            text-transform: uppercase;
        `,
    attrs: {
      "x": "13",
      "y": "25",
      "fill": "rgba(237, 137, 111, 1)"
    }
  }, [_c('tspan', {
    attrs: {
      "x": "13",
      "dy": "1em"
    }
  }, [_vm._v("Improve well-being")]), _vm._v(" "), _c('tspan', {
    attrs: {
      "x": "13",
      "dy": "1.2em"
    }
  }, [_vm._v("outcomes")])]), _vm._v(" "), _c('text', {
    staticClass: "stat-number",
    staticStyle: {
      "font-family": "'Mazzard Soft M'",
      "font-style": "normal",
      "font-weight": "400",
      "font-size": "56.6886px",
      "line-height": "71px",
      "letter-spacing": "-0.02em"
    },
    attrs: {
      "x": "20",
      "y": "190",
      "fill": "#292832"
    }
  }), _vm._v(" "), _c('text', {
    style: `
            font-family: 'Mazzard Soft M';
            font-style: normal;
            font-weight: 400;
            font-size: 56.6886px;
            line-height: 71px;
            letter-spacing: -0.02em;
        `,
    attrs: {
      "x": "88",
      "y": "190",
      "fill": "#292832"
    }
  }, [_vm._v("\n          %\n        ")]), _vm._v(" "), _c('path', {
    staticClass: "arrow-up",
    attrs: {
      "d": "M183.678 160.574C184.23 160.036 185.11 160.037 185.661 160.576L198.795 173.451C199.066 173.716 199.219 174.079 199.22 174.458C199.222 174.837 199.071 175.201 198.802 175.468L195.086 179.161C194.547 179.696 193.681 179.712 193.123 179.195L188.988 175.363V189.932C188.988 190.715 188.353 191.35 187.57 191.35H181.716C180.933 191.35 180.299 190.715 180.299 189.932V175.38L176.218 179.191C175.664 179.709 174.8 179.698 174.258 179.168L170.491 175.475C170.219 175.208 170.066 174.843 170.066 174.461C170.066 174.08 170.22 173.715 170.493 173.449L183.678 160.574Z",
      "fill": "white",
      "stroke": "#ACAABB",
      "stroke-width": "2.83443",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M205.133 189.826C204.946 189.996 204.81 190.319 204.81 190.574V191.016C204.81 191.34 205.065 191.595 205.388 191.595H212.259C212.582 191.595 212.837 191.34 212.837 191.016V190.285C212.837 189.962 212.582 189.724 212.259 189.724H207.837L210.286 187.394C211.936 185.829 212.735 184.622 212.735 183.397C212.735 181.476 210.967 179.894 208.722 179.894C207.072 179.894 205.661 180.761 204.861 182.122C204.691 182.394 204.827 182.734 205.116 182.87L205.916 183.261C205.984 183.295 206.069 183.312 206.137 183.312C206.341 183.312 206.545 183.21 206.664 183.006C207.123 182.241 207.854 181.765 208.722 181.765C209.81 181.765 210.695 182.53 210.695 183.448C210.695 184.18 210.15 185.03 209.062 186.084L205.133 189.826ZM214.633 189.826C214.446 189.996 214.31 190.319 214.31 190.574V191.016C214.31 191.34 214.565 191.595 214.888 191.595H221.759C222.082 191.595 222.337 191.34 222.337 191.016V190.285C222.337 189.962 222.082 189.724 221.759 189.724H217.337L219.786 187.394C221.436 185.829 222.235 184.622 222.235 183.397C222.235 181.476 220.466 179.894 218.222 179.894C216.572 179.894 215.16 180.761 214.361 182.122C214.191 182.394 214.327 182.734 214.616 182.87L215.415 183.261C215.483 183.295 215.569 183.312 215.637 183.312C215.841 183.312 216.045 183.21 216.164 183.006C216.623 182.241 217.354 181.765 218.222 181.765C219.31 181.765 220.194 182.53 220.194 183.448C220.194 184.18 219.65 185.03 218.562 186.084L214.633 189.826ZM225.51 190.302C225.323 190.523 225.34 190.846 225.561 191.033L225.851 191.271C225.953 191.357 226.055 191.391 226.174 191.391C226.327 191.391 226.463 191.322 226.582 191.203L234.779 181.425C234.966 181.187 234.949 180.88 234.728 180.693L234.422 180.438C234.32 180.353 234.201 180.319 234.099 180.319C233.946 180.319 233.793 180.387 233.691 180.506L225.51 190.302ZM223.572 182.836C223.572 184.52 224.847 185.778 226.531 185.778C228.215 185.778 229.473 184.52 229.473 182.836C229.473 181.17 228.215 179.894 226.531 179.894C224.847 179.894 223.572 181.17 223.572 182.836ZM225.289 182.836C225.289 182.156 225.834 181.612 226.531 181.612C227.211 181.612 227.755 182.156 227.755 182.836C227.755 183.533 227.211 184.061 226.531 184.061C225.834 184.061 225.289 183.533 225.289 182.836ZM230.749 188.857C230.749 190.557 232.024 191.816 233.691 191.816C235.374 191.816 236.65 190.557 236.65 188.857C236.65 187.207 235.374 185.931 233.691 185.931C232.024 185.931 230.749 187.207 230.749 188.857ZM232.466 188.857C232.466 188.176 233.01 187.649 233.691 187.649C234.388 187.649 234.915 188.176 234.915 188.857C234.915 189.554 234.388 190.098 233.691 190.098C233.01 190.098 232.466 189.554 232.466 188.857Z",
      "fill": "#292832"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "line",
    attrs: {
      "d": "M21.0887 117.655L48.8609 96.7771H71.8769H92.8057L126.677 104.497L148.597 96.7771L169.151 87.9856H190.245L215.453 79.2886L233.5 77.2886",
      "stroke": "#ED896F",
      "stroke-width": "4.25165"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "234.698",
      "y1": "69.4158",
      "x2": "234.698",
      "y2": "105.201",
      "stroke": "#DEDEE5",
      "stroke-width": "1.41722"
    }
  }), _vm._v(" "), _c('defs', [_c('filter', {
    attrs: {
      "id": "filter0_d_4887_40067",
      "x": "4.25183",
      "y": "198.438",
      "width": "246.596",
      "height": "45.351",
      "filterUnits": "userSpaceOnUse",
      "color-interpolation-filters": "sRGB"
    }
  }, [_c('feFlood', {
    attrs: {
      "flood-opacity": "0",
      "result": "BackgroundImageFix"
    }
  }), _vm._v(" "), _c('feColorMatrix', {
    attrs: {
      "in": "SourceAlpha",
      "type": "matrix",
      "values": "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
      "result": "hardAlpha"
    }
  }), _vm._v(" "), _c('feOffset', {
    attrs: {
      "dy": "2.83443"
    }
  }), _vm._v(" "), _c('feGaussianBlur', {
    attrs: {
      "stdDeviation": "8.5033"
    }
  }), _vm._v(" "), _c('feComposite', {
    attrs: {
      "in2": "hardAlpha",
      "operator": "out"
    }
  }), _vm._v(" "), _c('feColorMatrix', {
    attrs: {
      "type": "matrix",
      "values": "0 0 0 0 0.247059 0 0 0 0 0.227451 0 0 0 0 0.282353 0 0 0 0.04 0"
    }
  }), _vm._v(" "), _c('feBlend', {
    attrs: {
      "mode": "normal",
      "in2": "BackgroundImageFix",
      "result": "effect1_dropShadow_4887_40067"
    }
  }), _vm._v(" "), _c('feBlend', {
    attrs: {
      "mode": "normal",
      "in": "SourceGraphic",
      "in2": "effect1_dropShadow_4887_40067",
      "result": "shape"
    }
  })], 1), _vm._v(" "), _c('filter', {
    attrs: {
      "id": "filter1_d_4887_40067",
      "x": "4.25299",
      "y": "198.436",
      "width": "145.588",
      "height": "45.351",
      "filterUnits": "userSpaceOnUse",
      "color-interpolation-filters": "sRGB"
    }
  }, [_c('feFlood', {
    attrs: {
      "flood-opacity": "0",
      "result": "BackgroundImageFix"
    }
  }), _vm._v(" "), _c('feColorMatrix', {
    attrs: {
      "in": "SourceAlpha",
      "type": "matrix",
      "values": "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
      "result": "hardAlpha"
    }
  }), _vm._v(" "), _c('feOffset', {
    attrs: {
      "dy": "2.83443"
    }
  }), _vm._v(" "), _c('feGaussianBlur', {
    attrs: {
      "stdDeviation": "8.5033"
    }
  }), _vm._v(" "), _c('feComposite', {
    attrs: {
      "in2": "hardAlpha",
      "operator": "out"
    }
  }), _vm._v(" "), _c('feColorMatrix', {
    attrs: {
      "type": "matrix",
      "values": "0 0 0 0 0.247059 0 0 0 0 0.227451 0 0 0 0 0.282353 0 0 0 0.04 0"
    }
  }), _vm._v(" "), _c('feBlend', {
    attrs: {
      "mode": "normal",
      "in2": "BackgroundImageFix",
      "result": "effect1_dropShadow_4887_40067"
    }
  }), _vm._v(" "), _c('feBlend', {
    attrs: {
      "mode": "normal",
      "in": "SourceGraphic",
      "in2": "effect1_dropShadow_4887_40067",
      "result": "shape"
    }
  })], 1)])]), _vm._v(" "), _c('svg', {
    ref: "esg-stat-2-mobile",
    staticClass: "slider__item mr-8",
    attrs: {
      "width": "256",
      "height": "256",
      "viewBox": "0 0 256 256",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('rect', {
    attrs: {
      "x": "0.0986328",
      "width": "255.099",
      "height": "255.099",
      "rx": "5.66886",
      "fill": "white"
    }
  }), _vm._v(" "), _c('g', {
    attrs: {
      "filter": "url(#filter0_d_4887_40022)"
    }
  }, [_c('rect', {
    attrs: {
      "x": "233.939",
      "y": "212.611",
      "width": "11.3377",
      "height": "212.582",
      "rx": "5.66886",
      "transform": "rotate(90 233.939 212.611)",
      "fill": "#327DB9",
      "fill-opacity": "0.2",
      "shape-rendering": "crispEdges"
    }
  })]), _vm._v(" "), _c('rect', {
    staticClass: "bar",
    attrs: {
      "x": "54.0032",
      "y": "221.611",
      "width": "11",
      "height": "211.895",
      "rx": "5.5",
      "transform": "rotate(-90.0166 39.0032 239.06)",
      "fill": "#327DB9"
    }
  }), _vm._v(" "), _c('text', {
    style: `
            font-family: 'Mazzard Soft M';
            font-style: normal;
            font-weight: 700;
            font-size: 17;
            line-height: 23px;
            letter-spacing: 0.04em;
            text-transform: uppercase;
        `,
    attrs: {
      "x": "13",
      "y": "25",
      "fill": "rgba(50, 125, 185, 1)"
    }
  }, [_c('tspan', {
    attrs: {
      "x": "13",
      "dy": "1em"
    }
  }, [_vm._v("Increase")]), _vm._v(" "), _c('tspan', {
    attrs: {
      "x": "13",
      "dy": "1.2em"
    }
  }, [_vm._v("engagement")])]), _vm._v(" "), _c('text', {
    staticClass: "stat-number",
    staticStyle: {
      "font-family": "'Mazzard Soft M'",
      "font-style": "normal",
      "font-weight": "400",
      "font-size": "56.6886px",
      "line-height": "71px",
      "letter-spacing": "-0.02em"
    },
    attrs: {
      "x": "20",
      "y": "190",
      "fill": "#292832"
    }
  }), _vm._v(" "), _c('text', {
    style: `
            font-family: 'Mazzard Soft M';
            font-style: normal;
            font-weight: 400;
            font-size: 56.6886px;
            line-height: 71px;
            letter-spacing: -0.02em;
        `,
    attrs: {
      "x": "88",
      "y": "190",
      "fill": "#292832"
    }
  }, [_vm._v("\n          %\n        ")]), _vm._v(" "), _c('path', {
    staticClass: "arrow-down",
    attrs: {
      "d": "M183.777 190.947C184.328 191.485 185.209 191.484 185.759 190.945L198.894 178.07C199.164 177.805 199.317 177.442 199.319 177.063C199.32 176.684 199.169 176.32 198.9 176.053L195.184 172.36C194.645 171.824 193.779 171.809 193.222 172.326L189.086 176.158V161.588C189.086 160.806 188.452 160.171 187.669 160.171H181.814C181.032 160.171 180.397 160.806 180.397 161.588V176.141L176.316 172.329C175.762 171.812 174.899 171.822 174.357 172.353L170.59 176.046C170.317 176.313 170.164 176.678 170.165 177.059C170.165 177.441 170.319 177.806 170.592 178.072L183.777 190.947Z",
      "fill": "white",
      "stroke": "#ACAABB",
      "stroke-width": "2.83443",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M205.504 171.703C205.606 171.924 205.793 172.043 205.997 172.043C206.082 172.043 206.167 172.026 206.252 171.975L207.817 171.193V179.679C207.817 180.002 208.055 180.257 208.395 180.257H209.194C209.518 180.257 209.756 180.002 209.756 179.679V169.356C209.756 169.016 209.518 168.778 209.194 168.778H208.82C208.582 168.778 208.225 168.863 207.987 168.982L205.436 170.257C205.147 170.393 205.028 170.734 205.181 171.04L205.504 171.703ZM211.925 170.002C211.925 170.325 212.163 170.58 212.486 170.58H217.758L213.83 179.73C213.693 180.019 213.83 180.257 214.17 180.257H215.139C215.462 180.257 215.819 180.019 215.955 179.73L219.595 171.193C219.731 170.904 219.833 170.427 219.833 170.104V169.356C219.833 169.016 219.578 168.778 219.255 168.778H212.486C212.163 168.778 211.925 169.016 211.925 169.356V170.002ZM222.736 178.965C222.549 179.186 222.566 179.509 222.787 179.696L223.076 179.934C223.178 180.019 223.28 180.053 223.399 180.053C223.552 180.053 223.688 179.985 223.807 179.866L232.004 170.087C232.191 169.849 232.174 169.543 231.953 169.356L231.647 169.101C231.545 169.016 231.426 168.982 231.324 168.982C231.171 168.982 231.018 169.05 230.916 169.169L222.736 178.965ZM220.797 171.499C220.797 173.182 222.073 174.441 223.756 174.441C225.44 174.441 226.698 173.182 226.698 171.499C226.698 169.832 225.44 168.557 223.756 168.557C222.073 168.557 220.797 169.832 220.797 171.499ZM222.515 171.499C222.515 170.819 223.059 170.274 223.756 170.274C224.436 170.274 224.981 170.819 224.981 171.499C224.981 172.196 224.436 172.723 223.756 172.723C223.059 172.723 222.515 172.196 222.515 171.499ZM227.974 177.519C227.974 179.22 229.249 180.478 230.916 180.478C232.6 180.478 233.875 179.22 233.875 177.519C233.875 175.87 232.6 174.594 230.916 174.594C229.249 174.594 227.974 175.87 227.974 177.519ZM229.692 177.519C229.692 176.839 230.236 176.312 230.916 176.312C231.613 176.312 232.14 176.839 232.14 177.519C232.14 178.216 231.613 178.761 230.916 178.761C230.236 178.761 229.692 178.216 229.692 177.519Z",
      "fill": "#292832"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "line",
    attrs: {
      "d": "M21.1855 117.655L44.446 114.523L69.4958 102.446H98.5714L121.832 93.0523L143.75 87.2371L169.247 82.3167H194.745L217.558 87.2371L234.108 93.0523",
      "stroke": "#327DB9",
      "stroke-width": "4.25165"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "234.795",
      "y1": "76.5017",
      "x2": "234.795",
      "y2": "112.287",
      "stroke": "#DEDEE5",
      "stroke-width": "1.41722"
    }
  }), _vm._v(" "), _c('defs', [_c('filter', {
    attrs: {
      "id": "filter0_d_4887_40022",
      "x": "4.35046",
      "y": "198.439",
      "width": "246.596",
      "height": "45.351",
      "filterUnits": "userSpaceOnUse",
      "color-interpolation-filters": "sRGB"
    }
  }, [_c('feFlood', {
    attrs: {
      "flood-opacity": "0",
      "result": "BackgroundImageFix"
    }
  }), _vm._v(" "), _c('feColorMatrix', {
    attrs: {
      "in": "SourceAlpha",
      "type": "matrix",
      "values": "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
      "result": "hardAlpha"
    }
  }), _vm._v(" "), _c('feOffset', {
    attrs: {
      "dy": "2.83443"
    }
  }), _vm._v(" "), _c('feGaussianBlur', {
    attrs: {
      "stdDeviation": "8.5033"
    }
  }), _vm._v(" "), _c('feComposite', {
    attrs: {
      "in2": "hardAlpha",
      "operator": "out"
    }
  }), _vm._v(" "), _c('feColorMatrix', {
    attrs: {
      "type": "matrix",
      "values": "0 0 0 0 0.247059 0 0 0 0 0.227451 0 0 0 0 0.282353 0 0 0 0.04 0"
    }
  }), _vm._v(" "), _c('feBlend', {
    attrs: {
      "mode": "normal",
      "in2": "BackgroundImageFix",
      "result": "effect1_dropShadow_4887_40022"
    }
  }), _vm._v(" "), _c('feBlend', {
    attrs: {
      "mode": "normal",
      "in": "SourceGraphic",
      "in2": "effect1_dropShadow_4887_40022",
      "result": "shape"
    }
  })], 1), _vm._v(" "), _c('filter', {
    attrs: {
      "id": "filter1_d_4887_40022",
      "x": "4.35075",
      "y": "198.436",
      "width": "164.397",
      "height": "45.351",
      "filterUnits": "userSpaceOnUse",
      "color-interpolation-filters": "sRGB"
    }
  }, [_c('feFlood', {
    attrs: {
      "flood-opacity": "0",
      "result": "BackgroundImageFix"
    }
  }), _vm._v(" "), _c('feColorMatrix', {
    attrs: {
      "in": "SourceAlpha",
      "type": "matrix",
      "values": "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
      "result": "hardAlpha"
    }
  }), _vm._v(" "), _c('feOffset', {
    attrs: {
      "dy": "2.83443"
    }
  }), _vm._v(" "), _c('feGaussianBlur', {
    attrs: {
      "stdDeviation": "8.5033"
    }
  }), _vm._v(" "), _c('feComposite', {
    attrs: {
      "in2": "hardAlpha",
      "operator": "out"
    }
  }), _vm._v(" "), _c('feColorMatrix', {
    attrs: {
      "type": "matrix",
      "values": "0 0 0 0 0.247059 0 0 0 0 0.227451 0 0 0 0 0.282353 0 0 0 0.04 0"
    }
  }), _vm._v(" "), _c('feBlend', {
    attrs: {
      "mode": "normal",
      "in2": "BackgroundImageFix",
      "result": "effect1_dropShadow_4887_40022"
    }
  }), _vm._v(" "), _c('feBlend', {
    attrs: {
      "mode": "normal",
      "in": "SourceGraphic",
      "in2": "effect1_dropShadow_4887_40022",
      "result": "shape"
    }
  })], 1)])]), _vm._v(" "), _c('svg', {
    ref: "esg-stat-3-mobile",
    staticClass: "slider__item mr-8",
    attrs: {
      "width": "256",
      "height": "256",
      "viewBox": "0 0 256 256",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('rect', {
    attrs: {
      "x": "0.197266",
      "width": "255.099",
      "height": "255.099",
      "rx": "5.66886",
      "fill": "white"
    }
  }), _vm._v(" "), _c('g', {
    attrs: {
      "filter": "url(#filter0_d_4887_40052)"
    }
  }, [_c('rect', {
    attrs: {
      "x": "234.038",
      "y": "212.611",
      "width": "11.3377",
      "height": "212.582",
      "rx": "5.66886",
      "transform": "rotate(90 234.038 212.611)",
      "fill": "#985F8C",
      "fill-opacity": "0.2",
      "shape-rendering": "crispEdges"
    }
  })]), _vm._v(" "), _c('rect', {
    staticClass: "bar",
    attrs: {
      "x": "54.0032",
      "y": "221.611",
      "width": "11",
      "height": "211.895",
      "rx": "5.5",
      "transform": "rotate(-90.0166 39.0032 239.06)",
      "fill": "#985F8C"
    }
  }), _vm._v(" "), _c('text', {
    style: `
            font-family: 'Mazzard Soft M';
            font-style: normal;
            font-weight: 700;
            font-size: 17;
            line-height: 23px;
            letter-spacing: 0.04em;
            text-transform: uppercase;
        `,
    attrs: {
      "x": "13",
      "y": "25",
      "fill": "rgba(152, 95, 140, 1)"
    }
  }, [_c('tspan', {
    attrs: {
      "x": "13",
      "dy": "1em"
    }
  }, [_vm._v("Improve")]), _vm._v(" "), _c('tspan', {
    attrs: {
      "x": "13",
      "dy": "1.2em"
    }
  }, [_vm._v("Retention")])]), _vm._v(" "), _c('text', {
    staticClass: "stat-number",
    staticStyle: {
      "font-family": "'Mazzard Soft M'",
      "font-style": "normal",
      "font-weight": "400",
      "font-size": "56.6886px",
      "line-height": "71px",
      "letter-spacing": "-0.02em"
    },
    attrs: {
      "x": "20",
      "y": "190",
      "fill": "#292832"
    }
  }), _vm._v(" "), _c('text', {
    style: `
            font-family: 'Mazzard Soft M';
            font-style: normal;
            font-weight: 400;
            font-size: 56.6886px;
            line-height: 71px;
            letter-spacing: -0.02em;
        `,
    attrs: {
      "x": "88",
      "y": "190",
      "fill": "#292832"
    }
  }, [_vm._v("\n          %\n        ")]), _vm._v(" "), _c('path', {
    staticClass: "arrow-up",
    attrs: {
      "d": "M183.875 160.574C184.426 160.036 185.307 160.037 185.857 160.576L198.992 173.451C199.262 173.716 199.416 174.079 199.417 174.458C199.418 174.837 199.267 175.201 198.999 175.468L195.282 179.161C194.743 179.697 193.877 179.712 193.32 179.195L189.184 175.363V189.933C189.184 190.715 188.55 191.35 187.767 191.35H181.912C181.13 191.35 180.495 190.715 180.495 189.933V175.38L176.414 179.192C175.86 179.709 174.997 179.699 174.455 179.168L170.688 175.475C170.416 175.208 170.262 174.843 170.263 174.462C170.263 174.08 170.417 173.715 170.69 173.449L183.875 160.574Z",
      "fill": "white",
      "stroke": "#ACAABB",
      "stroke-width": "2.83443",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M205.602 183.041C205.704 183.262 205.891 183.381 206.095 183.381C206.18 183.381 206.265 183.364 206.35 183.313L207.915 182.53V191.017C207.915 191.34 208.153 191.595 208.493 191.595H209.292C209.615 191.595 209.854 191.34 209.854 191.017V180.694C209.854 180.354 209.615 180.116 209.292 180.116H208.918C208.68 180.116 208.323 180.201 208.085 180.32L205.534 181.595C205.245 181.731 205.126 182.071 205.279 182.377L205.602 183.041ZM218.655 182.496C218.825 182.667 219.029 182.752 219.233 182.752C219.319 182.752 219.387 182.735 219.472 182.701L220.271 182.309C220.577 182.156 220.662 181.816 220.475 181.578C219.693 180.541 218.383 179.894 216.87 179.894C214.353 179.894 212.465 181.663 212.465 183.993V188.024C212.465 190.166 214.302 191.816 216.751 191.816C219.182 191.816 221.036 190.183 221.036 188.058C221.036 185.881 219.182 184.231 216.768 184.231C215.866 184.231 215.05 184.486 214.421 184.911V183.959C214.421 182.718 215.458 181.765 216.836 181.765C217.584 181.765 218.23 182.054 218.655 182.496ZM216.751 186.102C218.026 186.102 218.995 186.935 218.995 188.058C218.995 189.129 218.026 189.945 216.751 189.945C215.458 189.945 214.489 189.112 214.489 188.007C214.489 186.935 215.458 186.102 216.751 186.102ZM224.096 190.302C223.909 190.524 223.926 190.847 224.147 191.034L224.436 191.272C224.538 191.357 224.64 191.391 224.759 191.391C224.912 191.391 225.048 191.323 225.167 191.204L233.365 181.425C233.552 181.187 233.535 180.881 233.313 180.694L233.007 180.439C232.905 180.354 232.786 180.32 232.684 180.32C232.531 180.32 232.378 180.388 232.276 180.507L224.096 190.302ZM222.157 182.837C222.157 184.52 223.433 185.779 225.116 185.779C226.8 185.779 228.058 184.52 228.058 182.837C228.058 181.17 226.8 179.894 225.116 179.894C223.433 179.894 222.157 181.17 222.157 182.837ZM223.875 182.837C223.875 182.156 224.419 181.612 225.116 181.612C225.797 181.612 226.341 182.156 226.341 182.837C226.341 183.534 225.797 184.061 225.116 184.061C224.419 184.061 223.875 183.534 223.875 182.837ZM229.334 188.857C229.334 190.558 230.609 191.816 232.276 191.816C233.96 191.816 235.235 190.558 235.235 188.857C235.235 187.207 233.96 185.932 232.276 185.932C230.609 185.932 229.334 187.207 229.334 188.857ZM231.052 188.857C231.052 188.177 231.596 187.649 232.276 187.649C232.973 187.649 233.501 188.177 233.501 188.857C233.501 189.554 232.973 190.098 232.276 190.098C231.596 190.098 231.052 189.554 231.052 188.857Z",
      "fill": "#292832"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "line",
    attrs: {
      "d": "M21.2843 117.655L44.5448 108.855L69.5945 102.446H98.6631L121.931 93.0524L147.387 108.855L169.346 87.9857L197.329 102.446H215.601L232.571 87.2373",
      "stroke": "#985F8C",
      "stroke-width": "4.25165"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "234.893",
      "y1": "69.4163",
      "x2": "234.893",
      "y2": "105.202",
      "stroke": "#DEDEE5",
      "stroke-width": "1.41722"
    }
  }), _vm._v(" "), _c('defs', [_c('filter', {
    attrs: {
      "id": "filter0_d_4887_40052",
      "x": "4.4491",
      "y": "198.439",
      "width": "246.596",
      "height": "45.351",
      "filterUnits": "userSpaceOnUse",
      "color-interpolation-filters": "sRGB"
    }
  }, [_c('feFlood', {
    attrs: {
      "flood-opacity": "0",
      "result": "BackgroundImageFix"
    }
  }), _vm._v(" "), _c('feColorMatrix', {
    attrs: {
      "in": "SourceAlpha",
      "type": "matrix",
      "values": "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
      "result": "hardAlpha"
    }
  }), _vm._v(" "), _c('feOffset', {
    attrs: {
      "dy": "2.83443"
    }
  }), _vm._v(" "), _c('feGaussianBlur', {
    attrs: {
      "stdDeviation": "8.5033"
    }
  }), _vm._v(" "), _c('feComposite', {
    attrs: {
      "in2": "hardAlpha",
      "operator": "out"
    }
  }), _vm._v(" "), _c('feColorMatrix', {
    attrs: {
      "type": "matrix",
      "values": "0 0 0 0 0.247059 0 0 0 0 0.227451 0 0 0 0 0.282353 0 0 0 0.04 0"
    }
  }), _vm._v(" "), _c('feBlend', {
    attrs: {
      "mode": "normal",
      "in2": "BackgroundImageFix",
      "result": "effect1_dropShadow_4887_40052"
    }
  }), _vm._v(" "), _c('feBlend', {
    attrs: {
      "mode": "normal",
      "in": "SourceGraphic",
      "in2": "effect1_dropShadow_4887_40052",
      "result": "shape"
    }
  })], 1), _vm._v(" "), _c('filter', {
    attrs: {
      "id": "filter1_d_4887_40052",
      "x": "4.44922",
      "y": "198.436",
      "width": "210.557",
      "height": "45.351",
      "filterUnits": "userSpaceOnUse",
      "color-interpolation-filters": "sRGB"
    }
  }, [_c('feFlood', {
    attrs: {
      "flood-opacity": "0",
      "result": "BackgroundImageFix"
    }
  }), _vm._v(" "), _c('feColorMatrix', {
    attrs: {
      "in": "SourceAlpha",
      "type": "matrix",
      "values": "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
      "result": "hardAlpha"
    }
  }), _vm._v(" "), _c('feOffset', {
    attrs: {
      "dy": "2.83443"
    }
  }), _vm._v(" "), _c('feGaussianBlur', {
    attrs: {
      "stdDeviation": "8.5033"
    }
  }), _vm._v(" "), _c('feComposite', {
    attrs: {
      "in2": "hardAlpha",
      "operator": "out"
    }
  }), _vm._v(" "), _c('feColorMatrix', {
    attrs: {
      "type": "matrix",
      "values": "0 0 0 0 0.247059 0 0 0 0 0.227451 0 0 0 0 0.282353 0 0 0 0.04 0"
    }
  }), _vm._v(" "), _c('feBlend', {
    attrs: {
      "mode": "normal",
      "in2": "BackgroundImageFix",
      "result": "effect1_dropShadow_4887_40052"
    }
  }), _vm._v(" "), _c('feBlend', {
    attrs: {
      "mode": "normal",
      "in": "SourceGraphic",
      "in2": "effect1_dropShadow_4887_40052",
      "result": "shape"
    }
  })], 1)])]), _vm._v(" "), _c('svg', {
    ref: "esg-stat-4-mobile",
    staticClass: "slider__item mr-8",
    attrs: {
      "width": "256",
      "height": "256",
      "viewBox": "0 0 256 256",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('rect', {
    attrs: {
      "x": "0.295898",
      "width": "255.099",
      "height": "255.099",
      "rx": "5.66886",
      "fill": "white"
    }
  }), _vm._v(" "), _c('g', {
    attrs: {
      "filter": "url(#filter0_d_4887_40037)"
    }
  }, [_c('rect', {
    attrs: {
      "x": "234.136",
      "y": "212.611",
      "width": "11.3377",
      "height": "212.582",
      "rx": "5.66886",
      "transform": "rotate(90 234.136 212.611)",
      "fill": "#3C9EB7",
      "fill-opacity": "0.2",
      "shape-rendering": "crispEdges"
    }
  })]), _vm._v(" "), _c('rect', {
    staticClass: "bar",
    attrs: {
      "x": "54.0032",
      "y": "221.611",
      "width": "11",
      "height": "211.895",
      "rx": "5.5",
      "transform": "rotate(-90.0166 39.0032 239.06)",
      "fill": "#3C9EB7"
    }
  }), _vm._v(" "), _c('text', {
    style: `
            font-family: 'Mazzard Soft M';
            font-style: normal;
            font-weight: 700;
            font-size: 17;
            line-height: 23px;
            letter-spacing: 0.04em;
            text-transform: uppercase;
        `,
    attrs: {
      "x": "13",
      "y": "25",
      "fill": "#3C9EB7"
    }
  }, [_c('tspan', {
    attrs: {
      "x": "13",
      "dy": "1em"
    }
  }, [_vm._v("Demonstrate")]), _vm._v(" "), _c('tspan', {
    attrs: {
      "x": "13",
      "dy": "1.2em"
    }
  }, [_vm._v("leadership")])]), _vm._v(" "), _c('text', {
    staticClass: "stat-number",
    staticStyle: {
      "font-family": "'Mazzard Soft M'",
      "font-style": "normal",
      "font-weight": "400",
      "font-size": "56.6886px",
      "line-height": "71px",
      "letter-spacing": "-0.02em"
    },
    attrs: {
      "x": "20",
      "y": "190",
      "fill": "#292832"
    }
  }), _vm._v(" "), _c('text', {
    style: `
            font-family: 'Mazzard Soft M';
            font-style: normal;
            font-weight: 400;
            font-size: 56.6886px;
            line-height: 71px;
            letter-spacing: -0.02em;
        `,
    attrs: {
      "x": "88",
      "y": "190",
      "fill": "#292832"
    }
  }, [_vm._v("\n          %\n        ")]), _vm._v(" "), _c('path', {
    staticClass: "arrow-up",
    attrs: {
      "d": "M183.974 160.574C184.525 160.036 185.406 160.037 185.956 160.576L199.09 173.451C199.361 173.716 199.514 174.079 199.515 174.458C199.517 174.837 199.366 175.201 199.097 175.468L195.381 179.161C194.842 179.697 193.976 179.712 193.419 179.195L189.283 175.363V189.933C189.283 190.715 188.648 191.35 187.866 191.35H182.011C181.228 191.35 180.594 190.715 180.594 189.933V175.38L176.513 179.192C175.959 179.709 175.095 179.699 174.554 179.168L170.786 175.475C170.514 175.208 170.361 174.843 170.361 174.462C170.362 174.081 170.516 173.715 170.788 173.449L183.974 160.574Z",
      "fill": "white",
      "stroke": "#ACAABB",
      "stroke-width": "2.83443",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M205.428 189.826C205.241 189.996 205.105 190.32 205.105 190.575V191.017C205.105 191.34 205.36 191.595 205.684 191.595H212.554C212.877 191.595 213.132 191.34 213.132 191.017V190.286C213.132 189.962 212.877 189.724 212.554 189.724H208.132L210.581 187.394C212.231 185.83 213.03 184.622 213.03 183.398C213.03 181.476 211.262 179.895 209.017 179.895C207.367 179.895 205.956 180.762 205.156 182.122C204.986 182.395 205.122 182.735 205.411 182.871L206.211 183.262C206.279 183.296 206.364 183.313 206.432 183.313C206.636 183.313 206.84 183.211 206.959 183.007C207.418 182.241 208.149 181.765 209.017 181.765C210.105 181.765 210.99 182.531 210.99 183.449C210.99 184.18 210.445 185.031 209.357 186.085L205.428 189.826ZM216.306 190.303C216.119 190.524 216.136 190.847 216.357 191.034L216.646 191.272C216.748 191.357 216.85 191.391 216.969 191.391C217.122 191.391 217.258 191.323 217.377 191.204L225.574 181.425C225.761 181.187 225.744 180.881 225.523 180.694L225.217 180.439C225.115 180.354 224.996 180.32 224.894 180.32C224.741 180.32 224.588 180.388 224.486 180.507L216.306 190.303ZM214.367 182.837C214.367 184.52 215.642 185.779 217.326 185.779C219.01 185.779 220.268 184.52 220.268 182.837C220.268 181.17 219.01 179.895 217.326 179.895C215.642 179.895 214.367 181.17 214.367 182.837ZM216.085 182.837C216.085 182.156 216.629 181.612 217.326 181.612C218.006 181.612 218.551 182.156 218.551 182.837C218.551 183.534 218.006 184.061 217.326 184.061C216.629 184.061 216.085 183.534 216.085 182.837ZM221.544 188.857C221.544 190.558 222.819 191.816 224.486 191.816C226.17 191.816 227.445 190.558 227.445 188.857C227.445 187.207 226.17 185.932 224.486 185.932C222.819 185.932 221.544 187.207 221.544 188.857ZM223.261 188.857C223.261 188.177 223.806 187.65 224.486 187.65C225.183 187.65 225.71 188.177 225.71 188.857C225.71 189.554 225.183 190.099 224.486 190.099C223.806 190.099 223.261 189.554 223.261 188.857Z",
      "fill": "#292832"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "line",
    attrs: {
      "d": "M21.3829 117.655L44.6434 108.855L69.6932 102.446L93.0999 96.777L122.029 93.0522L143.948 87.2371L169.445 87.9854L196.108 87.9858L217.755 87.2371H232.669",
      "stroke": "#3C9EB7",
      "stroke-width": "4.25165"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "234.992",
      "y1": "69.416",
      "x2": "234.992",
      "y2": "105.201",
      "stroke": "#DEDEE5",
      "stroke-width": "1.41722"
    }
  }), _vm._v(" "), _c('defs', [_c('filter', {
    attrs: {
      "id": "filter0_d_4887_40037",
      "x": "4.547",
      "y": "198.438",
      "width": "246.596",
      "height": "45.351",
      "filterUnits": "userSpaceOnUse",
      "color-interpolation-filters": "sRGB"
    }
  }, [_c('feFlood', {
    attrs: {
      "flood-opacity": "0",
      "result": "BackgroundImageFix"
    }
  }), _vm._v(" "), _c('feColorMatrix', {
    attrs: {
      "in": "SourceAlpha",
      "type": "matrix",
      "values": "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
      "result": "hardAlpha"
    }
  }), _vm._v(" "), _c('feOffset', {
    attrs: {
      "dy": "2.83443"
    }
  }), _vm._v(" "), _c('feGaussianBlur', {
    attrs: {
      "stdDeviation": "8.5033"
    }
  }), _vm._v(" "), _c('feComposite', {
    attrs: {
      "in2": "hardAlpha",
      "operator": "out"
    }
  }), _vm._v(" "), _c('feColorMatrix', {
    attrs: {
      "type": "matrix",
      "values": "0 0 0 0 0.247059 0 0 0 0 0.227451 0 0 0 0 0.282353 0 0 0 0.04 0"
    }
  }), _vm._v(" "), _c('feBlend', {
    attrs: {
      "mode": "normal",
      "in2": "BackgroundImageFix",
      "result": "effect1_dropShadow_4887_40037"
    }
  }), _vm._v(" "), _c('feBlend', {
    attrs: {
      "mode": "normal",
      "in": "SourceGraphic",
      "in2": "effect1_dropShadow_4887_40037",
      "result": "shape"
    }
  })], 1), _vm._v(" "), _c('filter', {
    attrs: {
      "id": "filter1_d_4887_40037",
      "x": "4.54694",
      "y": "198.436",
      "width": "193.855",
      "height": "45.351",
      "filterUnits": "userSpaceOnUse",
      "color-interpolation-filters": "sRGB"
    }
  }, [_c('feFlood', {
    attrs: {
      "flood-opacity": "0",
      "result": "BackgroundImageFix"
    }
  }), _vm._v(" "), _c('feColorMatrix', {
    attrs: {
      "in": "SourceAlpha",
      "type": "matrix",
      "values": "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
      "result": "hardAlpha"
    }
  }), _vm._v(" "), _c('feOffset', {
    attrs: {
      "dy": "2.83443"
    }
  }), _vm._v(" "), _c('feGaussianBlur', {
    attrs: {
      "stdDeviation": "8.5033"
    }
  }), _vm._v(" "), _c('feComposite', {
    attrs: {
      "in2": "hardAlpha",
      "operator": "out"
    }
  }), _vm._v(" "), _c('feColorMatrix', {
    attrs: {
      "type": "matrix",
      "values": "0 0 0 0 0.247059 0 0 0 0 0.227451 0 0 0 0 0.282353 0 0 0 0.04 0"
    }
  }), _vm._v(" "), _c('feBlend', {
    attrs: {
      "mode": "normal",
      "in2": "BackgroundImageFix",
      "result": "effect1_dropShadow_4887_40037"
    }
  }), _vm._v(" "), _c('feBlend', {
    attrs: {
      "mode": "normal",
      "in": "SourceGraphic",
      "in2": "effect1_dropShadow_4887_40037",
      "result": "shape"
    }
  })], 1)])])])], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }